// removed by extract-text-webpack-plugin
module.exports = {"button":"HamburgerButton-module__button____oRla","icon":"HamburgerButton-module__icon___17Y2w"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Header/HamburgerButton.module.scss
// module id = 241
// module chunks = 0 1